module.exports = __webpack_public_path__ + "static/media/background.a1e308f7.svg";